import { store } from 'store/index'

export class GetStartedVm {
  get showGetStarted() {
    return (
      store.featureFlags.featureEnabled('get_started_modal') &&
      store.currentUser?.orgRole === 'admin'
    )
  }

  get hasFramework() {
    return Boolean(store.currentUser?.org?.hasFrameworks)
  }

  get showGenerateWithAi() {
    return (
      !this.hasFramework &&
      store.featureFlags.featureEnabled('framework_builder')
    )
  }
}
